import { createContext, useContext, useState, useEffect } from 'react'
import en from './lang/en'
import fr from './lang/fr'
import ar from './lang/ar'

const translations = { en, fr, ar }

const LanguageContext = createContext()

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('app_lang') || 'fr'
  })

  useEffect(() => {
    localStorage.setItem('app_lang', lang)
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = lang
  }, [lang])

  const t = (key) => translations[lang]?.[key] || translations.en?.[key] || key

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useTranslation() {
  return useContext(LanguageContext)
}

export default LanguageContext
